export default __webpack_public_path__ + "static/font-a22abadc283e17da0df3df6e146aafdb.woff2";